<div class="container grid-container">
  <app-towers-bet-section></app-towers-bet-section>
  <app-towers-area></app-towers-area>
</div>
